import { variant } from './variant';
import { type VariantSettings } from './variantConfiguration';
import { variantRegistry } from './variantRegistry';

export function variantPath<T extends keyof VariantSettings>(
  key: T
): VariantSettings[T] {
  return variantRegistry[variant][key];
}
